module.exports = __webpack_public_path__ + "img/turbo_on.35573e7a.png";